import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { className: "text-h6" }, "Фильтры", -1)
const _hoisted_2 = { class: "row q-mt-md" }
const _hoisted_3 = {
  key: 0,
  class: "col-12"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Поиск:", -1)
const _hoisted_5 = {
  key: 1,
  class: "col-12"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Приложение:", -1)
const _hoisted_7 = {
  key: 2,
  class: "col-12"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Оффер:", -1)
const _hoisted_9 = {
  key: 3,
  class: "col-12"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Кампания:", -1)
const _hoisted_11 = {
  key: 4,
  class: "col-12"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Группа:", -1)
const _hoisted_13 = {
  key: 5,
  class: "col-12"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, "Группа:", -1)
const _hoisted_15 = {
  key: 6,
  class: "col-12"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "Группа:", -1)
const _hoisted_17 = {
  key: 7,
  class: "col-12"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("b", null, "Группа:", -1)
const _hoisted_19 = {
  key: 8,
  class: "col-12"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("b", null, "Событие:", -1)
const _hoisted_21 = {
  key: 9,
  class: "col-12"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", null, "Рекламодатель:", -1)
const _hoisted_23 = {
  key: 10,
  class: "col-12"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", null, "Страны:", -1)
const _hoisted_25 = {
  key: 11,
  class: "col-12"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("b", null, "Источник трафика:", -1)
const _hoisted_27 = {
  key: 12,
  class: "col-12"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("b", null, "Афф. менеджер:", -1)
const _hoisted_29 = {
  key: 13,
  class: "col-12"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("b", null, "Статус:", -1)
const _hoisted_31 = {
  key: 14,
  class: "col-12"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", null, "Статус:", -1)
const _hoisted_33 = {
  key: 15,
  class: "col-12"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("b", null, "Вертикаль:", -1)
const _hoisted_35 = {
  key: 16,
  class: "col-12"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("b", null, "Тип конверсии:", -1)
const _hoisted_37 = {
  key: 17,
  class: "col-12"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("b", null, "Раздел:", -1)
const _hoisted_39 = {
  key: 18,
  class: "col-12"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("b", null, "Лендинги:", -1)
const _hoisted_41 = {
  key: 19,
  class: "col-12"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("b", null, "Категория:", -1)
const _hoisted_43 = {
  key: 20,
  class: "col-12"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("b", null, "Группировать по:", -1)
const _hoisted_45 = {
  key: 21,
  class: "col-12"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("b", null, "Группировка 2:", -1)
const _hoisted_47 = {
  key: 22,
  class: "col-2"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("b", null, "Группировка 3:", -1)
const _hoisted_49 = {
  key: 23,
  class: "col-12"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("b", null, "Дата:", -1)
const _hoisted_51 = {
  key: 24,
  class: "col-12"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("b", null, "Дата депозита:", -1)
const _hoisted_53 = {
  key: 25,
  class: "self-center q-mt-md q-mr-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.showDialog) = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "card q-pa-none",
        style: {"min-width":"350px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { className: "q-card__section q-card__section--vert q-px-lg row justify-between items-center" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", null, [
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  icon: "close",
                  flat: "",
                  rounded: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { className: "q-pt-none q-form q-px-lg" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (
              _ctx.hideForAffiliates &&
                _ctx.hideForStatistics &&
                _ctx.hideForAdvertisers &&
                _ctx.hideForOffers &&
                _ctx.hideForCampaigns &&
                _ctx.hideForPayouts
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _hoisted_4,
                      _createVNode(_component_q_input, {
                        outlined: "",
                        dense: "",
                        debounce: "500",
                        class: "col-12 q-mr-lg",
                        modelValue: _ctx.search,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.hideForBalances && _ctx.isAdminTds)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _hoisted_6,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.mobileAppId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.mobileAppId) = $event)),
                        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeFilters('mobileAppId', _ctx.filters.mobileAppId))),
                        outlined: "",
                        class: "col-4 q-mr-lg",
                        options: _ctx.apps,
                        onFilter: _ctx.getMobileApps,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.hideForAffiliates &&
                _ctx.hideForPayouts &&
                _ctx.hideForAdvertisers &&
                !_ctx.isAdminTds &&
                _ctx.hideForLandings &&
                _ctx.hideForTrafficSources &&
                _ctx.hideForRotations
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.offerId,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.offerId) = $event)),
                        onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeFilters('offerId', _ctx.filters.offerId))),
                        outlined: "",
                        class: "col-12 q-mr-lg",
                        options: _ctx.offers,
                        onFilter: _ctx.getOffers,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.hideForStatistics &&
                _ctx.hideForPayouts &&
                _ctx.hideForAffiliates &&
                _ctx.hideForOffers &&
                _ctx.hideForAdvertisers &&
                !_ctx.isAdminTds &&
                _ctx.hideForLandings &&
                _ctx.hideForTrafficSources &&
                _ctx.hideForRotations
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.campaignId,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.campaignId) = $event)),
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeFilters('campaignId', _ctx.filters.campaignId))),
                        outlined: "",
                        class: "col-12 q-mr-lg",
                        options: _ctx.campaigns,
                        onFilter: _ctx.getCampaigns,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForCampaigns && _ctx.isBuying)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.groupId,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.groupId) = $event)),
                        onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onChangeFilters('groupId', _ctx.filters.groupId))),
                        outlined: "",
                        class: "col-4 q-mr-lg",
                        options: _ctx.groups,
                        onFilter: _ctx.getCampaignsGroups,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForRotations && _ctx.isBuying)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.groupId,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters.groupId) = $event)),
                        onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onChangeFilters('groupId', _ctx.filters.groupId))),
                        outlined: "",
                        class: "col-4 q-mr-lg",
                        options: _ctx.groups,
                        onFilter: _ctx.getRotationsGroups,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForOffers && _ctx.isBuying)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.groupId,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters.groupId) = $event)),
                        onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onChangeFilters('groupId', _ctx.filters.groupId))),
                        outlined: "",
                        class: "col-4 q-mr-lg",
                        options: _ctx.groups,
                        onFilter: _ctx.getOfferGroups,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForLandings && _ctx.isBuying)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.groupId,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filters.groupId) = $event)),
                        onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onChangeFilters('groupId', _ctx.filters.groupId))),
                        outlined: "",
                        class: "col-4 q-mr-lg",
                        options: _ctx.groups,
                        onFilter: _ctx.getLandingGroups,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                (
              !_ctx.isAdminTds &&
                _ctx.hideForStatistics &&
                _ctx.hideForConversions &&
                _ctx.hideForPayouts &&
                _ctx.hideForAffiliates &&
                _ctx.hideForOffers &&
                _ctx.hideForAdvertisers &&
                _ctx.hideForCampaigns &&
                _ctx.hideForClickLogs &&
                _ctx.hideForLandings &&
                _ctx.hideForTrafficSources &&
                _ctx.hideForFinances &&
                _ctx.hideForRotations
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.eventType,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.filters.eventType) = $event)),
                        onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onChangeFilters('eventType', _ctx.filters.eventType))),
                        outlined: "",
                        class: "col-12 q-mr-lg",
                        options: _ctx.postbackEventTypes,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.hideForAffiliates &&
                _ctx.hideForPayouts &&
                _ctx.hideForLogs &&
                _ctx.hideForCampaigns &&
                _ctx.hideForLandings &&
                _ctx.hideForTrafficSources &&
                !_ctx.isAdminTds &&
                _ctx.hideForRotations
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.advertiserId,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.filters.advertiserId) = $event)),
                        onBlur: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onChangeFilters('advertiserId', _ctx.filters.advertiserId))),
                        outlined: "",
                        class: "col-12 q-mr-lg",
                        options: _ctx.advertisers,
                        onFilter: _cache[20] || (_cache[20] = 
                (value, updateFn) =>
                  _ctx.getOptionsByField(value, updateFn, 'advertisers')
              ),
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.hideForPayouts &&
                _ctx.hideForLogs &&
                _ctx.hideForAdvertisers &&
                _ctx.hideForLandings &&
                _ctx.hideForTrafficSources &&
                _ctx.hideForRotations
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _hoisted_24,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.geoId,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.filters.geoId) = $event)),
                        onBlur: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onChangeFilters('geoId', _ctx.filters.geoId))),
                        outlined: "",
                        class: "col-12 q-mr-lg",
                        options: _ctx.geos,
                        onFilter: _cache[23] || (_cache[23] = 
                (value, updateFn) => _ctx.getOptionsByField(value, updateFn, 'geos')
              ),
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (
              !_ctx.hideForCampaigns || !_ctx.hideForStatistics || !_ctx.hideForConversions
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.trafficSourceId,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.filters.trafficSourceId) = $event)),
                        onBlur: _cache[25] || (_cache[25] = ($event: any) => (
                _ctx.onChangeFilters('trafficSourceId', _ctx.filters.trafficSourceId)
              )),
                        outlined: "",
                        class: "col-4 q-mr-lg",
                        options: _ctx.trafficSources,
                        onFilter: _ctx.getTrafficSources,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isPartners && (!_ctx.hideForAffiliates || !_ctx.hideForFinances))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        disable: true,
                        modelValue: _ctx.filters.managerId,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.filters.managerId) = $event)),
                        onBlur: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onChangeFilters('managerId', _ctx.filters.managerId))),
                        outlined: "",
                        class: "col-12 q-mr-lg",
                        options: _ctx.admins,
                        onFilter: _cache[28] || (_cache[28] = 
                (value, updateFn) =>
                  _ctx.getOptionsByField(value, updateFn, 'admins')
              ),
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForCampaigns)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _hoisted_30,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.campaignStatus,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.filters.campaignStatus) = $event)),
                        onBlur: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onChangeFilters('campaignStatus', _ctx.filters.campaignStatus))),
                        outlined: "",
                        class: "col-12 q-mr-lg",
                        options: _ctx.campaignStatuses,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForOffers)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.status,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.filters.status) = $event)),
                        onBlur: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onChangeFilters('status', _ctx.filters.status))),
                        outlined: "",
                        class: "col-12 q-mr-lg",
                        options: _ctx.offerStatuses,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.vertical,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.filters.vertical) = $event)),
                        onBlur: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onChangeFilters('vertical', _ctx.filters.vertical))),
                        outlined: "",
                        class: "col-12 q-mr-lg",
                        options: _ctx.verticals,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.hideForAffiliates &&
                _ctx.hideForPayouts &&
                _ctx.hideForLogs &&
                _ctx.hideForOffers &&
                _ctx.hideForAdvertisers &&
                _ctx.hideForCampaigns &&
                _ctx.hideForLandings &&
                _ctx.hideForTrafficSources &&
                !_ctx.isAdminTds &&
                _ctx.hideForRotations
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.rewardType,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.filters.rewardType) = $event)),
                        onBlur: _cache[36] || (_cache[36] = ($event: any) => (_ctx.onChangeFilters('rewardType', _ctx.filters.rewardType))),
                        outlined: "",
                        class: "col-12 q-mr-lg",
                        options: _ctx.rewardTypes,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                ((!_ctx.hideForStatistics || !_ctx.hideForConversions) && _ctx.isBuying)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _hoisted_38,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.department,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.filters.department) = $event)),
                        onBlur: _cache[38] || (_cache[38] = ($event: any) => (_ctx.onChangeFilters('department', _ctx.filters.department))),
                        outlined: "",
                        class: "col-4 q-mr-lg",
                        options: _ctx.departments,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.hideForAffiliates &&
                _ctx.hideForPayouts &&
                _ctx.hideForLogs &&
                _ctx.hideForOffers &&
                _ctx.hideForAdvertisers &&
                _ctx.hideForCampaigns &&
                _ctx.hideForLandings &&
                _ctx.hideForTrafficSources &&
                !_ctx.isAdminTds &&
                _ctx.hideForRotations
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _hoisted_40,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.landingId,
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.filters.landingId) = $event)),
                        outlined: "",
                        class: "col-12 q-mr-lg",
                        options: _ctx.promos,
                        onBlur: _cache[40] || (_cache[40] = ($event: any) => (_ctx.onChangeFilters('landingId', _ctx.filters.landingId))),
                        onFilter: _ctx.getPromos,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _hoisted_42,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.categoryId,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.filters.categoryId) = $event)),
                        outlined: "",
                        disable: _ctx.filters.vertical === undefined,
                        class: "col-12 q-mr-lg",
                        options: _ctx.categories,
                        onBlur: _cache[42] || (_cache[42] = ($event: any) => (_ctx.onChangeFilters('categoryId', _ctx.filters.categoryId))),
                        onFilter: _ctx.getCategories,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "disable", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForStatistics || !_ctx.hideForFinances)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _hoisted_44,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.groupBy,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.filters.groupBy) = $event)),
                        outlined: "",
                        onBlur: _cache[44] || (_cache[44] = ($event: any) => (_ctx.onChangeFilters('groupBy', _ctx.filters.groupBy))),
                        class: "col-12 q-mr-lg",
                        options: _ctx.groupByOptions,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForStatistics)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _hoisted_46,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        modelValue: _ctx.filters.groupBy2,
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.filters.groupBy2) = $event)),
                        outlined: "",
                        onBlur: _cache[46] || (_cache[46] = ($event: any) => (_ctx.onChangeFilters('groupBy2', _ctx.filters.groupBy2))),
                        class: "col-4 q-mr-lg",
                        options: _ctx.groupByOptions2,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForStatistics)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _hoisted_48,
                      _createVNode(_component_q_select, {
                        dense: "",
                        "options-dense": "",
                        clearable: "",
                        modelValue: _ctx.filters.groupBy3,
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.filters.groupBy3) = $event)),
                        outlined: "",
                        onBlur: _cache[48] || (_cache[48] = ($event: any) => (_ctx.onChangeFilters('groupBy3', _ctx.filters.groupBy3))),
                        class: "col-4 q-mr-lg",
                        options: _ctx.groupByOptions2,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isAdminTds)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _hoisted_50,
                      _createVNode(_component_DatePicker, {
                        onChange: _ctx.onChangeDate,
                        from: _ctx.filters.dateFrom,
                        to: _ctx.filters.dateTo
                      }, null, 8, ["onChange", "from", "to"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForConversions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _hoisted_52,
                      _createVNode(_component_DatePicker, {
                        id: "2",
                        onChangeDate: _ctx.onChangeConversionDate,
                        from: _ctx.filters.conversionDateFrom,
                        to: _ctx.filters.conversionDateTo
                      }, null, 8, ["onChangeDate", "from", "to"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === 'black-list-logs')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createVNode(_component_q_checkbox, {
                        label: "Block geo",
                        "model-value": _ctx.filters.showBlockGeos,
                        onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.onChangeFilters('showBlockGeos', !_ctx.filters.showBlockGeos)))
                      }, null, 8, ["model-value"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            align: "center",
            class: "flex column text-primary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                disable: _ctx.loading,
                loading: _ctx.loading,
                "no-caps": "",
                rounded: "",
                color: "primary",
                label: "Добавить",
                onClick: _ctx.addFilters
              }, null, 8, ["disable", "loading", "onClick"]),
              _createVNode(_component_q_btn, {
                "no-caps": "",
                flat: "",
                class: "reset-btn q-mt-md",
                label: "Скинуть",
                onClick: _ctx.resetFilters
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}